import { appLanguage } from '@orientaction/reducers';
import { isYoutubeUrl } from '@orientaction/utils';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { localizedVideo } from '../../pages/Redesign/shared/components/VideoImport/bilingual';
import YoutubeIframe from '../VideoYoutubeEmbed';

interface MediaVideoPlayerProps {
  imageUrl?: string | null;
  videoUrl?: string | null;
  videoEn?: string | null;
  autoPlayVideoEn?: number | null;
  muteVideoEn?: number | null;
  autoPlayVideo?: number | null;
  muteVideo?: number | null;
  imageAlt?: string;
  imageClassName?: string;
  imageContainerClassName?: string;
  videoClassName?: string;
}

const MediaVideoPlayer: FC<MediaVideoPlayerProps> = ({
  imageUrl,
  videoUrl: frenchVideo,
  videoEn,
  autoPlayVideoEn,
  muteVideoEn,
  autoPlayVideo: frenchAutoPlay = 0,
  muteVideo: frenchMute = 0,
  imageAlt = 'media',
  imageClassName,
  imageContainerClassName,
  videoClassName,
}) => {
  const language = useSelector(appLanguage);
  const {
    video: videoUrl,
    autoPlayVideo,
    muteVideo,
  } = localizedVideo(
    {
      video: frenchVideo,
      videoEn,
      autoPlayVideo: frenchAutoPlay,
      muteVideo: frenchMute,
      autoPlayVideoEn,
      muteVideoEn,
    },
    language || 'FR'
  );
  if (videoUrl) {
    if (isYoutubeUrl(videoUrl)) {
      return (
        <YoutubeIframe
          key={videoUrl}
          url={videoUrl}
          autoPlay={autoPlayVideo || 0}
          mute={muteVideo === 1 ? 0 : 1}
        />
      );
    }

    return (
      <video
        key={videoUrl}
        className={videoClassName}
        src={videoUrl}
        controls={true}
        autoPlay={autoPlayVideo === 1}
        playsInline={true}
        style={{ width: '100%', display: 'block', borderRadius: 5 }}
        muted={muteVideo !== 1}>
        <track kind="captions" />
      </video>
    );
  }

  if (imageUrl) {
    return (
      <div className={imageContainerClassName}>
        <img className={imageClassName} src={imageUrl} alt={imageAlt} />
      </div>
    );
  }

  return null;
};

export default MediaVideoPlayer;
